import isObject from './is-object.js';
/**
 * This function merges objects together into a single object without modifying unnecessary key/values.
 * @param args - Objects to be merged
 * @returns Merged object
 *
 * @example
 * const obj1 = {
 *  arr: ['Inner', 'Array'],
 *  inObj: {
 *    val1: 'Inner Value'
 *  },
 * };
 *
 * const obj2 = {
 *   inObj: {
 *     val2: 'Replace Inner Value'
 *   },
 *   value: 'Simple String',
 * };
 *
 * deepMerge(obj1, obj2);
 *
 * Result
 * {
 *  arr: ["Inner", "Array"],
 *  inObj: {
 *    val1: "Inner Value",
 *    val2: "Replace Inner Value",
 *  },
 *  value: "Simple String",
 * }
 *
 */
function deepMerge(...args) {
    const mergedObject = {};
    const merge = (objectToMerge) => {
        for (const prop in objectToMerge) {
            if (!Object.prototype.hasOwnProperty.call(objectToMerge, prop)) {
                continue;
            }
            const areBothObjects = isObject(objectToMerge[prop]) && isObject(mergedObject[prop]);
            // Merging the object into the deep object
            // @ts-ignore: ignoring because TS keeps messing with types and does not recognize that mergedObject and objectToMerge could be Record<string, T> or T
            mergedObject[prop] = areBothObjects ? deepMerge(mergedObject[prop], objectToMerge[prop]) : objectToMerge[prop];
        }
    };
    // Loop through each object and conduct a merge
    for (const object of args) {
        merge(object);
    }
    return mergedObject;
}
export { deepMerge, };
//# sourceMappingURL=deep-merge.js.map